import {trackExpressCheckout} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from '../utils/utils';

type TRACKING_EXPRESS_CHECKOUT_EVENTS =
  | 'show'
  | 'impression'
  | 'submit'
  | 'fail'
  | 'close';
type TRACKING_EXPRESS_CHECKOUT_PAYMENT_METHOD =
  | 'paypal_instant'
  | 'ratepay_invoice';

export const useTrackExpressCheckoutEvents = () => {
  const {TrackingClient} = useTracking();
  return (
    action: TRACKING_EXPRESS_CHECKOUT_EVENTS,
    paymentMethod: TRACKING_EXPRESS_CHECKOUT_PAYMENT_METHOD,
  ) => {
    TrackingClient.track(() =>
      trackExpressCheckout({
        action,
        paymentMethod,
        sourceUrl:
          typeof window !== 'undefined' ? window.location.href : undefined,
      }),
    );
  };
};
